import React, { Component } from 'react';
import { colors } from 'helpers/ColorHelper';

export default class ApplicantPreviousAddress extends Component {
  render() {
    const style = {
      subMenuHeader: {
        backgroundColor: colors.BODY_GRAY,
        margin: '20px -15px',
        textAlign: 'center',
        color: colors.FADE_GRAY,
      },
    };

    const { previousAddress } = this.props;
    if (!previousAddress) return null;

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Previous Address</h5>
        </div>

        <div className="row">
          <h5 style={{ textAlign: 'center', textTransform: 'capitalize' }}>
            {previousAddress.unit_number} {previousAddress.street}, {previousAddress.city},{' '}
            {previousAddress.province}, {previousAddress.country} {previousAddress.postal_code}
          </h5>
        </div>
      </div>
    );
  }
}
